import { render, staticRenderFns } from "./RewardBoxConfirmation.vue?vue&type=template&id=662a0a1e"
import script from "./RewardBoxConfirmation.vue?vue&type=script&lang=js"
export * from "./RewardBoxConfirmation.vue?vue&type=script&lang=js"
import style0 from "./RewardBoxConfirmation.vue?vue&type=style&index=0&id=662a0a1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports